import React from 'react';

const IconCircleCheck = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.07808 17.3925C13.6668 17.3925 17.3866 13.6726 17.3866 9.08394C17.3866 4.49526 13.6668 0.775391 9.07808 0.775391C4.4894 0.775391 0.769531 4.49526 0.769531 9.08394C0.769531 13.6726 4.4894 17.3925 9.07808 17.3925ZM8.8641 12.4444L13.48 6.90541L12.0616 5.72341L8.09286 10.4858L6.03816 8.43115L4.7326 9.73671L7.50212 12.5062L8.21693 13.221L8.8641 12.4444Z"
        fill="#141414"
      />
    </svg>
  );
};

export default IconCircleCheck;
